import React from 'react'
import Head from 'next/head'
import dynamic from 'next/dynamic'

const Footer = dynamic(() => import('@/components/home/footer'))
const KPHead = dynamic(() => import('@/components/head'))
const TopNavigation = dynamic(() => import('@/components/top-navigation'))

import styled from 'styled-components'
import { Animation, Reveal } from 'react-genie'

const Riplay = () => {
  return (
    <RiplayStyle>
      <Reveal animation={Animation.FadeIn}>
        <KPHead metaTitle="riplay" />
        <TopNavigation />
        <div className="riplay">
          <h1 className="page-title">Ringkasan Informasi Produk dan Layanan (RIPLAY)</h1>
          <p className="page-desc">
            Ringkasan Informasi Produk dan/atau Layanan (RIPLAY) adalah dokumen atau sarana lain yang memuat
            karakteristik dan informasi penting atau utama mengenai produk dan/atau layanan jasa keuangan. RIPLAY
            bertujuan agar dapat meningkatkan efektivitas transparansi dan keterbukaan informasi kepada Konsumen.
          </p>

          {/* ===================== RINGKASAN INFORMASI PRODUK ===================== */}
          <div className="riplay-table-wrapper">
            <table className="riplay-table">
              <tbody>
                <tr className="section-header-dark">
                  <td colSpan={5}>RINGKASAN INFORMASI PRODUK ATAU LAYANAN VERSI UMUM</td>
                </tr>
                <tr>
                  <td className="label" colSpan={1}>
                    Nama Penerbit
                  </td>
                  <td className="value" colSpan={4}>
                    : PT Kredit Pintar Indonesia
                  </td>
                </tr>
                <tr>
                  <td className="label" colSpan={1}>
                    Jenis Produk
                  </td>
                  <td className="value" colSpan={4}>
                    : Pinjaman dana tunai tanpa agunan
                  </td>
                </tr>
                <tr>
                  <td className="label" colSpan={1}>
                    Nama Produk
                  </td>
                  <td className="value" colSpan={4}>
                    : Kredit Pintar
                  </td>
                </tr>
                <tr>
                  <td className="label" colSpan={1}>
                    Deskripsi Produk
                  </td>
                  <td className="value" colSpan={4}>
                    : Kredit Pintar adalah aplikasi penyedia layanan pinjaman meminjam tanpa agunan melalui aplikasi
                    perangkat selular untuk memenuhi kebutuhan dana tunai dengan mudah dan cepat.
                  </td>
                </tr>
                <tr>
                  <td className="label" colSpan={1}>
                    Mata Uang
                  </td>
                  <td className="value" colSpan={4}>
                    : Rupiah (IDR)
                  </td>
                </tr>
                <tr className="spacer-row">
                  <td colSpan={5} />
                </tr>

                {/* ===================== FITUR UTAMA PENDANAAN ANDA ===================== */}
                <tr className="section-header">
                  <td colSpan={5}>FITUR UTAMA PENDANAAN ANDA</td>
                </tr>
                <tr>
                  <td className="label">Jumlah Pendanaan</td>
                  <td className="value" colSpan={2}>
                    : Maksimum limit Rp 50.000.000,-
                  </td>

                  <td className="label">Nominal Angsuran**</td>
                  <td className="value">: Maksimum hingga Rp50.000.000,-</td>
                </tr>
                <tr>
                  <td className="label">Suku Bunga*</td>
                  <td className="value">: 1-5%</td>
                  <td className="value">Per Bulan</td>

                  <td className="label">Total biaya</td>
                  <td className="value">: Mengikuti manfaat ekonomi yang diatur oleh OJK</td>
                </tr>
                <tr>
                  <td className="label">Jangka Waktu Pendanaan/ tenor</td>
                  <td className="value">: 2-12</td>
                  <td className="value">Bulan</td>

                  <td className="label">Total Pendanaan yang diterima</td>
                  <td className="value">: Menyesuaikan biaya administrasi</td>
                </tr>
                <tr>
                  <td className="note" colSpan={6}>
                    *Tingkat suku bunga yang dikenakan kepada Penerima Dana didasarkan atas analisis Penyelenggara
                    LPBBTI berdasarkan kategorisasi risiko (risk grade) dan pemeringkatan pinjaman
                  </td>
                </tr>
                <tr>
                  <td className="note" colSpan={6}>
                    **Nominal Angsuran dan Total Biaya belum termasuk Pajak
                  </td>
                </tr>

                {/* ===================== MANFAAT & RISIKO ===================== */}
                <tr className="section-header">
                  <td colSpan={3}>MANFAAT</td>

                  <td colSpan={2}>RISIKO</td>
                </tr>
                <tr>
                  <td className="value" colSpan={3}>
                    Kredit Pintar dapat dimanfaatkan oleh pengguna untuk pemenuhan berbagai kebutuhan, baik kebutuhan
                    produktif maupun konsumtif dengan proses pengajuan yang mudah dan cepat.
                  </td>

                  <td className="value" colSpan={2}>
                    Bagi pengguna yang tidak menyelesaikan kewajibannya ada risiko yang ditanggung oleh nasabah seperti:
                    <div className="list">
                      1. Terjadinya biaya tambahan yang harus dibayarkan oleh nasabah akibat keterlambatan
                    </div>
                    <div className="list">2. Menjadi catatan buruk nasabah di laporan regulator</div>
                  </td>
                </tr>

                {/* ===================== BIAYA & PERSYARATAN DAN TATA CARA ===================== */}
                <tr className="section-header">
                  <td colSpan={3}>BIAYA</td>

                  <td colSpan={2}>PERSYARATAN DAN TATA CARA</td>
                </tr>
                <tr>
                  <td className="label">Biaya Administrasi</td>
                  <td className="value" colSpan={2}>
                    : Maksimum 0.3% per hari
                  </td>
                  <td className="value" colSpan={2} rowSpan={4}>
                    <div className="sub-heading">Persyaratan Pengguna</div>
                    <div className="list">1. Tercatat sebagai Warga Negara Indonesia.</div>
                    <div className="list">2. Usia diantara 18-60 tahun (*60 tahun pada saat pengajuan pinjaman).</div>
                    <div className="list">3. Memiliki KTP yang masih berlaku.</div>
                    <div className="list">4. Memiliki akun Bank sesuai dengan data KTP.</div>
                    <div className="list">5. Berdomisili di Indonesia.</div>
                    <div className="list">6. Memenuhi dokumen dan Data lain yang diperlukan.</div>

                    <div className="sub-heading">Cara Melakukan Pinjaman</div>
                    <div className="list">
                      1. Unduh aplikasi Kredit Pintar melalui Google Play Store atau Apple Store.
                    </div>
                    <div className="list">
                      2. Lakukan registrasi di aplikasi Kredit Pintar dan isi data diri sesuai dengan keadaan
                      sesungguhnya. Sebaliknya apabila tidak mengisi dengan data sesungguhnya dapat berujung ke
                      penolakan pinjaman dan merusak reputasi peminjam di mata pemberi pinjaman dan lembaga keuangan
                      lainnya.
                    </div>
                    <div className="list">3. Ajukan pinjaman sesuai dengan pilihan nominal yang tersedia.</div>
                    <div className="list">4. Tunggu persetujuan pengajuan pinjaman.</div>
                    <div className="list">
                      5. Dana akan cair ke rekening setelah persetujuan pinjaman diterima dan nasabah melakukan
                      tandatangan perjanjian.
                    </div>

                    <div className="sub-heading">Pengaduan Terkait Produk dan Layanan</div>
                    <div className="contact-line">
                      Email ke <a href="mailto:cs@kreditpintar.com">cs@kreditpintar.com</a>
                    </div>
                    <div className="contact-line">Hotline di (021) 50598882</div>
                    <div className="contact-line">Jam operasional: 08:00-17:00 WIB (Senin-Minggu)</div>
                    <div className="contact-line">
                      Kantor Operasional Layanan Pelanggan: Mandiri In Health Tower Lt. 3, Jl. Prof. DR. Satrio Kav.
                      E-IV No.6, Kuningan, Karet Kuningan, Kecamatan Setiabudi, Kota Jakarta Selatan, Daerah Khusus
                      Ibukota Jakarta 12940
                    </div>
                    <div className="contact-line">
                      Website:{' '}
                      <a href="https://kreditpintar.com" target="_blank" rel="noreferrer">
                        kreditpintar.com
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="label">Denda Keterlambatan</td>
                  <td className="value" colSpan={2}>
                    : Maksimum 0.3% per hari
                  </td>
                </tr>
                <tr>
                  <td className="label">Biaya Insidental (Biaya Pelunasan Dipercepat)</td>
                  <td className="value" colSpan={2}>
                    : Tidak ada
                  </td>
                </tr>
                <tr>
                  <td className="filler" colSpan={3} />
                </tr>

                {/* ===================== SIMULASI ===================== */}
                <tr className="section-header">
                  <td colSpan={5}>SIMULASI</td>
                </tr>
                <tr className="spacer-row">
                  <td colSpan={5} />
                </tr>
                <tr>
                  <td className="label">Jumlah Pokok Pendanaan</td>
                  <td className="value" colSpan={4}>
                    : Rp1.000.000,-
                  </td>
                </tr>
                <tr>
                  <td className="label">Total Biaya Administrasi sepanjang masa Tenor</td>
                  <td className="value" colSpan={4}>
                    : Rp180.098,-
                  </td>
                </tr>
                <tr>
                  <td className="label">Nilai Uang yang diterima Penerima Dana</td>
                  <td className="value" colSpan={4}>
                    : Rp935.000,-
                  </td>
                </tr>
                <tr>
                  <td className="label">Tenor Pendanaan</td>
                  <td className="value" colSpan={4}>
                    3 Bulan
                  </td>
                </tr>
                <tr>
                  <td className="label">Total Bunga</td>
                  <td className="value" colSpan={4}>
                    : Rp114.102,- (1.8%/Per Bulan)
                  </td>
                </tr>
                <tr>
                  <td className="label">Nilai uang yang harus dikembalikan saat selesai tenor</td>
                  <td className="value" colSpan={4}>
                    : Rp1.115.098,-
                  </td>
                </tr>
                <tr>
                  <td className="label">Nilai tagihan/cicilan per bulan (Total Pengembalian dibagi tenor bulan</td>
                  <td className="value" colSpan={4}>
                    : Rp371.700,-
                  </td>
                </tr>
                <tr className="spacer-row">
                  <td colSpan={5} />
                </tr>
                <tr>
                  <td className="label" colSpan={5}>
                    Ketentuan Jatuh Tempo
                  </td>
                </tr>
                <tr>
                  <td className="label">Pendanaan pertama tanggal</td>
                  <td className="value" colSpan={4}>
                    : 20 April 2026
                  </td>
                </tr>
                <tr>
                  <td className="label">Jatuh tempo pembayaran pertama</td>
                  <td className="value" colSpan={4}>
                    : 20 Mei 2026
                  </td>
                </tr>

                {/* ===================== INFORMASI TAMBAHAN ===================== */}
                <tr className="section-header">
                  <td colSpan={5}>INFORMASI TAMBAHAN</td>
                </tr>
                <tr>
                  <td className="value" colSpan={5}>
                    <div className="info-block">
                      <div className="list">
                        1. Untuk tujuan simulasi, perhitungan dilakukan berdasarkan 1 (satu) bulan setara dengan 30
                        (tiga puluh) hari kalender.
                      </div>
                      <div className="list">
                        2. Penyelenggara dengan persetujuan dari masing-masing Pengguna dapat melakukan pemroses data
                        pribadi Pengguna yang meliputi:
                        <div className="sub-list">(a) Pemerolehan dan pengumpulan;</div>
                        <div className="sub-list">(b) Pengolahan dan penganalisan;</div>
                        <div className="sub-list">(c) Penyimpanan;</div>
                        <div className="sub-list">(d) Perbaikan dan pembaruan;</div>
                        <div className="sub-list">
                          (e) Penampilan, pengumuman, transfer, penyebarluasan, atau pengungkapan;
                        </div>
                        <div className="sub-list">(f) Penghapusan atau pemusnahan; dan</div>
                        <div className="sub-list">
                          (g) Tindakan pemrosesan data pribadi lainnya sesuai yang diatur dalam peraturan
                          perundang-undangan yang berlaku.
                        </div>
                      </div>
                      <div className="list">
                        3. Biaya yang muncul dalam pinjaman antara lain:
                        <div className="sub-list">(a) Biaya Jasa Pemberi Dana</div>
                        <div className="sub-list">(b) Biaya Jasa Layanan</div>
                        <div className="sub-list">(c) Biaya Jasa Pembayaran</div>
                        <div className="sub-list">(d) Biaya denda keterlambatan</div>
                        <div className="sub-list">
                          (e) Total Biaya sepanjang masa tenor akan masuk ke dalam manfaat ekonomi.
                        </div>
                        <div className="sub-list">
                          (f) Biaya denda keterlambatan maksimal 0.3% per hari dan tidak akan melebihi 100% dari pokok
                          pinjaman.
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="value" colSpan={5}>
                    <div className="info-block">
                      <div className="disclaimer-title">Penafian/ Disclaimer (penting untuk dibaca)</div>
                      <div className="list">
                        1. Ringkasan Informasi Produk dan/atau Layanan ini hanya digunakan sebagai referensi untuk
                        memberikan penjelasan mengenai produk pendanaan multiguna dan bukan merupakan dan tidak
                        dimaksudkan untuk menciptakan suatu perjanjian pendanaan yang mengikat.
                      </div>
                      <div className="list">
                        2. Informasi yang tercakup dalam Ringkasan Informasi Produk dan/atau Layanan ini berlaku sejak
                        tanggal cetak dokumen sampai dengan pinjaman dilunasi.
                      </div>
                      <div className="list">
                        3. Informasi yang tercakup dalam RIPLAY Umum ini adalah ketentuan terbaru sampai dengan
                        diterbitkannya RIPLAY Umum yang lebih baru, dan Kredit Pintar berhak memperbarui informasi yang
                        tercantum pada RIPLAY Umum ini sewaktu-waktu.
                      </div>
                      <div className="list">
                        4. RIPLAY Umum ini hanya digunakan sebagai referensi untuk memberikan penjelasan mengenai produk
                        pinjaman tunai dan bukan merupakan suatu perjanjian pinjaman yang mengikat.
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <Footer />
      </Reveal>
    </RiplayStyle>
  )
}

export default Riplay

const RiplayStyle = styled.div`
  width: 100%;
  min-height: 30vh;
  color: #1f2329;
  background: #ffffff;

  .riplay {
    max-width: 1140px;
    margin: 0 auto;
    padding: 82px 16px 40px;
  }

  .page-title {
    margin: 42px 0 12px;
    font-size: 28px;
    font-family: Roboto-Medium, Roboto;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.87);
    line-height: 36px;
  }

  .page-desc {
    font-size: 15px;
    line-height: 24px;
    color: rgba(0, 0, 0, 0.74);
    margin-bottom: 24px;
  }

  .riplay-table-wrapper {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .riplay-table {
    min-width: 700px;
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    font-size: 14px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.87);
    display: flex;
    justify-content: center;
  }

  .riplay-table td {
    border: 1px solid #d0d5dd;
    padding: 10px 12px;
    vertical-align: top;
    word-break: break-word;
  }

  .riplay-table .section-header td {
    background: #f2f4f7;
    text-align: center;
    font-weight: 700;
    letter-spacing: 0.3px;
    padding: 12px;
    border-color: #d0d5dd;
  }

  .riplay-table .section-header-dark td {
    background: #000;
    color: #fff;
    text-align: center;
    font-weight: 700;
    letter-spacing: 0.3px;
    padding: 12px;
    border-color: #000;
  }

  .riplay-table .label {
    width: 16%;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.87);
  }

  .riplay-table .value {
    color: rgba(0, 0, 0, 0.74);
  }

  .riplay-table .spacer {
    width: 10px;
    border: none !important;
    padding: 0 !important;
    background: transparent;
  }

  .riplay-table .spacer-row td {
    border: none !important;
    padding: 6px 0 !important;
    background: transparent;
  }

  .riplay-table .note {
    border: none !important;
    padding: 0px 0px 0px !important;
    font-size: 13px;
    font-style: italic;
    color: rgba(0, 0, 0, 0.65);
  }

  .riplay-table .filler {
    display: none;
    border: none !important;
    padding: 0 !important;
    background: transparent;
  }

  .riplay-table .list {
    margin: 4px 0;
    padding-left: 0;
  }

  .riplay-table .sub-list {
    margin: 3px 0 3px 16px;
  }

  .riplay-table .sub-heading {
    font-weight: 600;
    color: rgba(0, 0, 0, 0.87);
    margin: 14px 0 6px;
    &:first-child {
      margin-top: 0;
    }
  }

  .riplay-table .contact-line {
    margin: 4px 0;
  }

  .riplay-table .contact-line a {
    color: #007aff;
    text-decoration: none;
  }

  .riplay-table .contact-line a:hover {
    text-decoration: underline;
  }

  .riplay-table .disclaimer-title {
    font-weight: 600;
    color: rgba(0, 0, 0, 0.87);
    margin-bottom: 6px;
  }

  .riplay-table .info-block .list {
    margin: 6px 0;
  }

  @media only screen and (max-width: 1000px) {
    .riplay {
      padding: 78px 16px 24px;
    }

    .page-title {
      margin-top: 12px;
      font-size: 22px;
      line-height: 28px;
    }

    .riplay-table {
      font-size: 13px;
      line-height: 18px;
    }

    .riplay-table td {
      padding: 8px;
    }

    .riplay-table .section-header td {
      font-size: 13px;
      padding: 10px 8px;
    }

    .riplay-table .section-header-dark td {
      font-size: 13px;
      padding: 10px 8px;
    }

    .riplay-table .label {
      width: 38%;
    }

    .riplay-table .spacer {
      width: 6px;
    }
  }
`
